import { Store } from "../Redux/Store";
import API from "./API";

const GET = async (url, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = Store.getState().Auth.user;
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      if (user && user.token) {
        headers.Authorization = "Bearer " + user.token;
      }

      const response = await fetch(API.BASR_URL + url, {
        method: "get",
        headers,
      });

      const text = await response.text();
      const json = text ? JSON.parse(text) : {};

      if (!response.ok) {
        const message = json?.message || json?.error || response.statusText || "Request failed";
        return reject(new Error(message));
      }

      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};

const POST = async (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = Store.getState().Auth.user;
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      if (user && user.token) {
        headers.Authorization = "Bearer " + user.token;
      }

      const response = await fetch(API.BASR_URL + url, {
        method: "post",
        headers,
        body: JSON.stringify(body),
      });

      const text = await response.text();
      const json = text ? JSON.parse(text) : {};

      if (!response.ok) {
        const message = json?.message || json?.error || response.statusText || "Request failed";
        return reject(new Error(message));
      }

      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};
const POST_IMAGE = async (url, imageFile) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!imageFile) {
        throw new Error("No image file provided");
      }

      const formData = new FormData();
      formData.append("file", imageFile);

      const response = await fetch(API.BASR_URL + url, {
        method: "post",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });

      const json = await response.json();
      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};

const PUT = async (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = Store.getState().Auth.user;
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      if (user && user.token) {
        headers.Authorization = "Bearer " + user.token;
      }

      const response = await fetch(API.BASR_URL + url, {
        method: "put",
        headers,
        body: JSON.stringify(body),
      });

      const text = await response.text();
      const json = text ? JSON.parse(text) : {};

      if (!response.ok) {
        const message = json?.message || json?.error || response.statusText || "Request failed";
        return reject(new Error(message));
      }

      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};

const DELETE = async (url) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = Store.getState().Auth.user;
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      if (user && user.token) {
        headers.Authorization = "Bearer " + user.token;
      }

      const response = await fetch(API.BASR_URL + url, {
        method: "delete",
        headers,
      });

      const text = await response.text();
      const json = text ? JSON.parse(text) : {};

      if (!response.ok) {
        const message = json?.message || json?.error || response.statusText || "Request failed";
        return reject(new Error(message));
      }

      resolve(json);
    } catch (error) {
      reject(error);
    }
  });
};

export { GET, POST, POST_IMAGE, PUT, DELETE };
